import { HttpClient, HttpParams } from '@angular/common/http';
import { GlueConfigurationService } from '../../../services/glue-configuration.service';
import { Observable } from 'rxjs';
import { IPurchaseActivityResponse } from '../data/purchase-activity.models';
import { AppUtils } from '../../../utils/app.utils';
import { inject, Injectable } from '@angular/core';
import { EPurchaseActivityEndpoints } from '../data/purchase-activity.configurations';

@Injectable({ providedIn: 'root' })
export class PurchaseActivityHttpService {
  private http: HttpClient = inject(HttpClient);
  private glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  /**
   * Fetch purchase activity data for specific page from the specified endpoint.
   * Limit of items per page is based on the current store's pagination settings in environments.
   * Sort by order_creation_date for archive-orders and by created_at for other endpoints.
   * @param {EPurchaseActivityEndpoints} endpoint
   * @param {number} page
   * @returns {Observable<IPurchaseActivityResponse>}
   */
  getPurchaseActivityData(endpoint: EPurchaseActivityEndpoints, page: number): Observable<IPurchaseActivityResponse> {
    const url: string = `${this.glueConfiguration.getEndpointUrl()}/${endpoint}`;
    const params: HttpParams = new HttpParams()
      .set('page', page)
      .set('limit', AppUtils.getCurrentStore().paginationSettingsPerFeature.purchaseActivity.limitPerPage)
      .set('sort', endpoint === EPurchaseActivityEndpoints.ARCHIVE_ORDERS ? '-order_creation_date' : '-created_at');
    return this.http.get<IPurchaseActivityResponse>(url, { params });
  }

  /**
   * Fetch a specific purchase activity item by its ID from the specified endpoint.
   * Data from response (IPurchaseActivityResponse) is an array of this one item.
   * @param {EPurchaseActivityEndpoints} endpoint
   * @param {string} itemId
   * @returns {Observable<IPurchaseActivityResponse>}
   */
  getPurchaseActivityItem(endpoint: EPurchaseActivityEndpoints, itemId: string): Observable<IPurchaseActivityResponse> {
    const url: string = `${this.glueConfiguration.getEndpointUrl()}/${endpoint}`;
    const params: HttpParams = new HttpParams().set('id', itemId);
    return this.http.get<IPurchaseActivityResponse>(url, { params });
  }
}
